<template>
  <div class="bg-light pt-3 pt-lg-5 pb-5">
    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="3" xl="2" class="p-0">
          <DashUserNav></DashUserNav>
        </b-col>
        <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">


          <h5 class="">Meus cartões</h5>


        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";

export default {
  name: 'Cards',
  components: {
    DashUserNav,

  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {


  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  watch: {

  }
}
</script>

<style scoped>

</style>
